// @ts-strict-ignore
import { IOperation } from './i-operation';
import { DrillingholePresetVO } from '@project/actions/drilling-hole/drilling-hole.vo';
import { ArticleUsageVO } from '@article/model/vo/article.vo';
import { DrillingHolePresetPresenter } from '@3d-scene/model3d/util/drillinghole/presenter/drilling-hole-preset.presenter';
import { ArticleUsageUtils } from '@article/util/article-usage-utils';
import { ArticleUsageInfoPropertyDef } from '@article/constants/article-usage-info-property-def';

export class UndoChangeDrillingHolesOperation implements IOperation {
  private _drillingHoleOffset: number;
  private _cachedDrillingHoleOffset: number;
  private _drillingHolePresetVO: DrillingholePresetVO;
  private _isPreset: boolean;

  constructor(
    private _mountingRailArticleUsage: ArticleUsageVO,
    drillingholeOffset: number,
    cachedDillingholeOffset: number,
    drillingholePresetVO: DrillingholePresetVO,
    private _mountingRailLength: number,
    private _newMountingRailLength: number,
    private _drillingHolePresetPresenter: DrillingHolePresetPresenter
  ) {
    if (
      drillingholePresetVO &&
      ArticleUsageUtils.getArticleUsageInfoPropertyBooleanValue(this._mountingRailArticleUsage, ArticleUsageInfoPropertyDef.HAS_DRILLINGHOLE_PRESET)
    ) {
      this._drillingHolePresetVO = drillingholePresetVO;
      this._drillingHoleOffset = drillingholeOffset;
      this._cachedDrillingHoleOffset = cachedDillingholeOffset;
      this._isPreset = true;
    }
  }

  public getQualifiedClassName(): string {
    return 'UndoChangeDrillingHolesOperation';
  }

  public getOperationDescription(): string {
    return '';
  }

  public async performRedo(): Promise<void> {
    if (this._isPreset) {
      await this._drillingHolePresetPresenter.updateDrillingHoles(
        this._mountingRailArticleUsage,
        this._mountingRailLength,
        this._newMountingRailLength,
        this._newMountingRailLength - this._mountingRailLength,
        this._drillingHoleOffset,
        this._drillingHoleOffset - this._cachedDrillingHoleOffset,
        this._drillingHolePresetVO,
        false
      );
    }
  }

  public async performUndo(): Promise<void> {
    if (this._isPreset) {
      await this._drillingHolePresetPresenter.updateDrillingHoles(
        this._mountingRailArticleUsage,
        this._mountingRailLength,
        this._newMountingRailLength,
        this._mountingRailLength - this._newMountingRailLength,
        this._cachedDrillingHoleOffset,
        this._cachedDrillingHoleOffset - this._drillingHoleOffset,
        this._drillingHolePresetVO,
        false
      );
    }
  }
}
